(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kiva-assembly-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kiva-assembly-videos'))customElements.define('kiva-assembly-videos',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const nodes=Array.from(this.childNodes),grid=document.createElement('div');grid.className='kiva-help__videos';let card=null;nodes.forEach(n=>{const text=n.textContent?.trim()||'';const heading=n.nodeType===1&&n.matches('p')&&n.querySelector('strong')&&text===n.querySelector('strong').textContent.trim()&&/assembly/i.test(text);if(heading){card=document.createElement('article');card.className='kiva-help__video';const h=document.createElement('h2');while(n.firstChild)h.append(n.firstChild);card.append(h);grid.append(card);n.remove()}else if(card&&n.nodeName!=='STYLE'){card.append(n)}else if(n.nodeType===1&&n.matches('p')&&!text&&!n.querySelector('iframe,img,a'))n.remove()});this.append(grid);this.querySelectorAll('iframe').forEach(f=>{f.loading='lazy';const title=f.closest('article')?.querySelector('h2')?.textContent;if(title)f.title=title})}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiva-gallery-toggle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kiva-gallery-toggle'))customElements.define('kiva-gallery-toggle',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;
    const button=this.querySelector('button');
    const grid=document.getElementById(button.getAttribute('aria-controls'));
    if(!grid)return;
    this.dataset.ready='true';grid.setAttribute('data-kiva-collapsed','');button.setAttribute('aria-expanded','false');
    button.addEventListener('click',()=>{
      const expanded=button.getAttribute('aria-expanded')!=='true';
      grid.toggleAttribute('data-kiva-collapsed',!expanded);button.setAttribute('aria-expanded',String(expanded));
      button.textContent=expanded?'Show fewer images':button.dataset.label;
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiva-mega-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kiva-menu-close'))customElements.define('kiva-menu-close',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('button').addEventListener('click',()=>this.closest('header-menu')?.dispatchEvent(new KeyboardEvent('keydown',{key:'Escape',bubbles:true})));}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiva-review-enhancements"] && !Shopify.designMode) return;
  try {
    (()=>{
 const stars=rating=>{const el=document.createElement('span');el.className='kiva-review-stars';el.setAttribute('role','img');el.setAttribute('aria-label',rating+' / 5');el.style.setProperty('--stars',(rating/5*100)+'%');const back=document.createElement('span');back.textContent='★★★★★';back.style.position='static';back.style.color='inherit';back.setAttribute('aria-hidden','true');const front=document.createElement('span');front.textContent='★★★★★';front.setAttribute('aria-hidden','true');el.append(back,front);return el};
 const enhance=()=>{document.querySelectorAll('#yotpo-reviews-section-data').forEach(root=>{const overall=root.querySelector('#yotpo-reviews-overall-rating');if(overall&&!overall.dataset.kivaEnhanced){const match=overall.textContent.match(/([0-5](?:\.\d+)?)\s*\/\s*5/);if(match){const rating=Number(match[1]);const score=document.createElement('div');score.className='kiva-review-score';score.textContent=match[1]+' / 5';overall.prepend(score,stars(rating));overall.dataset.kivaEnhanced='true'}}root.querySelectorAll('.yotpo-review[data-rating]').forEach(card=>{if(card.dataset.kivaEnhanced)return;const rating=Number(card.dataset.rating);if(Number.isFinite(rating)&&rating>=0&&rating<=5){card.prepend(stars(rating));card.dataset.kivaEnhanced='true'}})})};
 const start=()=>{enhance();const main=document.getElementById('MainContent');if(!main)return;let queued=false;const observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;enhance()})});observer.observe(main,{childList:true,subtree:true});document.addEventListener('shopify:section:load',enhance)};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
